import { t } from '@/features/i18n/utils';
import { ProjectBreadcrumbs } from '@/features/projects/components/project-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { MainScrollArea, MainHeader, Main, MainHeaderBackButton } from '@/ui/components/main';
import { H1 } from '@/ui/components/heading';
import { projectAccessUsersQuery, projectDetailsQuery } from '@/features/projects/queries';
import { Icon } from '@/ui/components/icon';
import { UserGroupIcon, PlusSignIcon } from '@hugeicons-pro/core-stroke-rounded';
import { ProjectMembersList } from '@/features/projects/components/project-members-list';
import { Button } from '@/ui/components/button';
import { AddProjectMembers } from '@/features/projects/components/add-project-members';
import { useState } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { canManageProject } from '@/features/projects/utils';
import { useAuth } from '@/features/auth';

export const Route = createFileRoute('/_authed/project/$projectId/members')({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.query({
      ...projectAccessUsersQuery(params.projectId, context.auth.user.organizationId),
      staleTime: 'static',
    }),
});

function RouteComponent() {
  const { projectId } = Route.useParams();
  const auth = useAuth();
  const { data: project } = useSuspenseQuery(projectDetailsQuery(projectId));
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const canManage = canManageProject(project, auth.user.organizationRole);

  return (
    <Main>
      <Header>
        <HeaderBackButton />
        <ProjectBreadcrumbs>
          <BreadcrumbPage>
            <Icon icon={UserGroupIcon} />
            {t({ en: 'Members', nb: 'Medlemmer' })}
          </BreadcrumbPage>
        </ProjectBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <MainScrollArea>
        <MainHeader>
          <H1>
            <MainHeaderBackButton />
            {t({ en: 'Members', nb: 'Medlemmer' })}
          </H1>
          {canManage && (
            <Button
              kind="with-icon"
              className="max-md:w-full"
              onClick={() => setAddDialogOpen(true)}
            >
              <Icon icon={PlusSignIcon} />
              {t({ en: 'Add members', nb: 'Inviter bruker' })}
            </Button>
          )}
        </MainHeader>
        <ProjectMembersList />
        <AddProjectMembers open={addDialogOpen} onOpenChange={setAddDialogOpen} />
      </MainScrollArea>
    </Main>
  );
}
